module.exports = __webpack_public_path__ + "img/title.bcf830ea.png";